export const initialState = {
  list: []
};
